import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoHelper from '../common/InfoHelper';
import { currencyFormatter } from '../../services/helperService';
import { BUDGET_TARGET_PERCENTAGE } from '../../utils/budgetCalculations';

interface BudgetLabelProps {
  mode: 'current' | 'past';
  amount: number;
  targetPercentage: number;
}

const BudgetLabel: React.FC<BudgetLabelProps> = ({ mode, amount, targetPercentage }) => {
  const { t } = useTranslation();

  let text: string;
  let isPositive: boolean;

  if (mode === 'current') {
    isPositive = amount > 0;
    text = isPositive
      ? t('dashboard.budgetLabel.remaining', { amount: currencyFormatter.format(amount) })
      : t('dashboard.budgetLabel.overBudgetNow', { amount: currencyFormatter.format(Math.abs(amount)) });
  } else {
    isPositive = amount <= 0;
    text = isPositive
      ? t('dashboard.budgetLabel.underBudgetPast', { amount: currencyFormatter.format(Math.abs(amount)) })
      : t('dashboard.budgetLabel.overBudgetPast', { amount: currencyFormatter.format(amount) });
  }

  const colorClass = isPositive
    ? 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300'
    : 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300';

  const descriptionKey =
    mode === 'current'
      ? 'dashboard.budgetLabel.info.descriptionCurrent'
      : 'dashboard.budgetLabel.info.descriptionPast';

  const targetLabel = `${targetPercentage.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${colorClass}`}>
      <span>{text}</span>
      <InfoHelper
        titleKey="dashboard.budgetLabel.info.title"
        titleValues={{ target: targetLabel }}
        descriptionKey={descriptionKey}
        descriptionValues={{ target: targetLabel }}
        iconSize={12}
      />
    </div>
  );
};

export default BudgetLabel;

export { BUDGET_TARGET_PERCENTAGE };
